export default {"src":"/pro/_next/static/media/mkr.60abeaf2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};